var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanAndRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 25.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.875 35.625H26.625V33.375H28.875V35.625ZM26.625 27.75H24.375V33.375H26.625V27.75ZM35.625 25.5H33.375V30H35.625V25.5ZM33.375 23.25H31.125V25.5H33.375V23.25ZM19.875 25.5H17.625V27.75H19.875V25.5ZM17.625 23.25H15.375V25.5H17.625V23.25ZM25.5 17.625H27.75V15.375H25.5V17.625ZM17.0625 17.0625V20.4375H20.4375V17.0625H17.0625ZM21 22.125H16.5C15.8812 22.125 15.375 21.6188 15.375 21V16.5C15.375 15.8812 15.8812 15.375 16.5 15.375H21C21.6188 15.375 22.125 15.8812 22.125 16.5V21C22.125 21.6188 21.6188 22.125 21 22.125ZM17.0625 30.5625V33.9375H20.4375V30.5625H17.0625ZM21 35.625H16.5C15.8812 35.625 15.375 35.1187 15.375 34.5V30C15.375 29.3812 15.8812 28.875 16.5 28.875H21C21.6188 28.875 22.125 29.3812 22.125 30V34.5C22.125 35.1187 21.6188 35.625 21 35.625ZM30.5625 17.0625V20.4375H33.9375V17.0625H30.5625ZM34.5 22.125H30C29.3812 22.125 28.875 21.6188 28.875 21V16.5C28.875 15.8812 29.3812 15.375 30 15.375H34.5C35.1187 15.375 35.625 15.8812 35.625 16.5V21C35.625 21.6188 35.1187 22.125 34.5 22.125ZM33.375 33.375V30H28.875V32.25H31.125V35.625H35.625V33.375H33.375ZM31.125 25.5H26.625V27.75H31.125V25.5ZM26.625 23.25H19.875V25.5H22.125V27.75H24.375V25.5H26.625V23.25ZM27.75 22.125V19.875H25.5V17.625H23.25V22.125H27.75ZM19.5938 17.9062H17.9062V19.5938H19.5938V17.9062ZM19.5938 31.4062H17.9062V33.0938H19.5938V31.4062ZM33.0938 17.9062H31.4062V19.5938H33.0938V17.9062Z",
    fill: "#006DB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanAndRegister);
export default __webpack_public_path__ + "static/media/scan-and-register.7110fd89f0e0047eef3aceb46c380e70.svg";
export { ForwardRef as ReactComponent };